import { API } from '@config';
import { HrPersonelServicesAnchorTable } from '@src/types/HrPersonelServicesAnchors';

export const getHrPersonelServicesForms = async () => {
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(`${API}/api/hr-personel-services-forms?populate=File&sort=id%3Adesc`, options);
  const data: HrPersonelServicesAnchorTable = await response.json();

  return data;
};
